import { GRID_SIZE, MAX_A8_WIDTH_MULTIPLIER } from './constants.js'
import type { GridCoordinate } from './types.js'

export function snapToGrid(x: number, y: number): GridCoordinate {
  // Corner-anchored snapping: snap to the top-left cell corner
  return {
    x: Math.floor(x / GRID_SIZE),
    y: Math.floor(y / GRID_SIZE)
  }
}

export function snapToPaperWidth(width: number, columnWidthUnits: number): number {
  const widthInUnits = Math.max(1, Math.round(width / GRID_SIZE))
  const multiples = Math.max(1, Math.round(widthInUnits / columnWidthUnits))
  const clampedMultiples = Math.min(multiples, MAX_A8_WIDTH_MULTIPLIER)
  return clampedMultiples * columnWidthUnits
}

export function toPixels(units: number): number {
  return units * GRID_SIZE
}

export function toUnits(pixels: number): number {
  return Math.round(pixels / GRID_SIZE)
}

// Snap horizontal units to column edges (multiples of column width)
export function snapXToColumn(xUnits: number, columnWidthUnits: number): number {
  return Math.round(xUnits / columnWidthUnits) * columnWidthUnits
}

// Bias horizontal position to the current column start instead of crossing the midpoint
export function snapXToColumnBiased(xUnits: number, columnWidthUnits: number): number {
  return Math.floor(xUnits / columnWidthUnits) * columnWidthUnits
}

// Snap vertical position to even grid rows (multiples of 2 units)
export function snapYToEven(yUnits: number): number {
  // Bias to the even row at/above the input to avoid dropping blocks below the tap
  return Math.floor(yUnits / 2) * 2
}

// Snap vertical position to the nearest even row (multiples of 2 units)
export function snapYToEvenNearest(yUnits: number): number {
  return Math.round(yUnits / 2) * 2
}
